module.exports = __webpack_public_path__ + "static/media/screws.e462586f.png";